import { render, staticRenderFns } from "./ModalReciboTotal.vue?vue&type=template&id=7f6f1aa6"
import script from "./ModalReciboTotal.vue?vue&type=script&lang=js"
export * from "./ModalReciboTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports